<template>
  <v-dialog v-model="show" persistent scrollable max-width="600">
    <v-card>
      <v-card-title class="primary white--text">
        <v-icon color="white" class="mr-2">mdi-camera</v-icon> {{ title }}
        <v-btn
          class="mt-n1"
          icon
          dark
          top
          right
          absolute
          @click="resetFormImage"
        >
          <v-icon color="grey">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-6">
        <div class="dropzone-input">
          <vue-dropzone
            ref="ImageVueDropzone"
            id="dropzone"
            :destroy-dropzone="true"
            :use-custom-slot="true"
            :options="dropzoneSingleImageOptions"
            @vdropzone-success="handleUploadSingleImageSuccess"
          >
            <div class="dropzone-custom-content">
              <v-icon x-large>mdi-file-image-outline</v-icon>
              <h3 class="dropzone-custom-title mt-2">
                Tarik dan letakkan <br />
                gambar Anda disini!
              </h3>
              <div class="subtitle">atau klik disini</div>
            </div>
          </vue-dropzone>
        </div>
        <v-alert
          v-if="error.message"
          text
          type="error"
          class="custom-alert my-4"
        >
          <p class="body-2 mb-0">
            {{ error.message }}
          </p>
        </v-alert>
      </v-card-text>
      <v-card-actions class="pb-6 px-6">
        <v-spacer></v-spacer>
        <v-btn
          small
          color="#fff"
          elevation="0"
          :disabled="loading"
          class="text-capitalize grey--text text--darken-1"
          @click="resetFormImage"
        >
          Batal
        </v-btn>
        <v-btn
          small
          light
          color="light-green"
          elevation="0"
          :disabled="loading"
          :loading="loading"
          @click="saveFormImage"
          class="white--text text-capitalize"
        >
          {{ buttonSave }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import dropzone from '@/mixins/dropzone';
export default {
  mixins: [dropzone],
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Unggah Gambar'
    },
    loading: {
      type: Boolean,
      default: false
    },
    returnObject: {
      type: Boolean,
      default: false
    },
    buttonSave: {
      type: String,
      default: 'Simpan Gambar'
    }
  },
  data() {
    return {
      image: null
    };
  },
  methods: {
    handleUploadSingleImageSuccess(file, response) {
      if (this.returnObject) {
        this.image = response.data.results;
      } else {
        this.image = response.data.results.url.compressed;
      }
    },
    saveFormImage() {
      if (this.image) {
        this.$emit('save', this.image);
      } else {
        this.error.message = 'Harap masukkan gambar';
      }
    },
    resetFormImage() {
      this.clearError();
      this.image = null;
      this.$refs.ImageVueDropzone.removeAllFiles(true);
      this.$emit('cancel');
    }
  }
};
</script>
